// ── Planilha do Psicólogo na Tela (núcleo puro) ───────────────────
// A relação que vai ao parceiro: quem da empresa tem o Psicólogo na Tela
// marcado — colaborador, Vida+ ou só adicional. O layout é o do arquivo que o
// parceiro devolveu como modelo (docs/Evo_Psicologo_na_Tela.xlsx): uma aba
// "colaboradores" com as 13 colunas abaixo, nesta ordem e com estes nomes.
//
// No modelo os dados estão deslocados uma coluna para a esquerda (a data cai
// em "Genero", o CPF em "Data_de_Admissao"). O cabeçalho é que manda: cada
// dado vai na coluna que o nomeia.

import type { Vida } from './ports/ICsRepository';
import { formatCpf, mascararTelefone } from './csModel';

export const PSICOLOGO_COLUNAS = [
  'Nome', 'Email', 'Genero', 'Nascimento', 'Cargo', 'Area', 'Departamento',
  'Regional', 'Pais', 'Celular', 'Data_de_Admissao', 'CPF', 'Codigo_de_Validacao',
] as const;

export const PSICOLOGO_ABA = 'colaboradores';

export type CelulaPsicologo = string | Date | null;

/** ISO aaaa-mm-dd → Date local (o escritor de xlsx lê os campos locais). */
const dataLocal = (iso: string): Date | null => {
  const [a, m, d] = String(iso || '').split('-').map(Number);
  return a && m && d ? new Date(a, m - 1, d) : null;
};

/**
 * As linhas da planilha: só vidas ativas com o Psicólogo na Tela marcado,
 * titular antes dos dependentes dele. `Area` leva o nome da empresa, que é
 * como o parceiro separa as unidades ("evo - setubal" no modelo). O que o CRM
 * não guarda (gênero, cargo, país, admissão, código) vai em branco.
 */
export const linhasPsicologoNaTela = (vidas: Vida[], empresaNome: string): CelulaPsicologo[][] => {
  const marcadas = vidas.filter(v => v.ativo && v.psicologo);
  const titulares = marcadas.filter(v => v.tipo === 'colaborador');
  const dependentesDe = (id: string | null) => marcadas.filter(v => v.tipo !== 'colaborador' && v.titularId === id);
  // Dependente cujo titular não está marcado (ou foi inativado) entra no fim:
  // ele tem o benefício mesmo que o titular não tenha.
  const ordenadas = [
    ...titulares.flatMap(t => [t, ...dependentesDe(t.id)]),
    ...marcadas.filter(v => v.tipo !== 'colaborador' && !titulares.some(t => t.id === v.titularId)),
  ];

  return ordenadas.map(v => [
    v.nome,
    v.email || null,
    null,
    dataLocal(v.dataNascimento),
    null,
    empresaNome || null,
    null,
    null,
    null,
    v.telefone ? mascararTelefone(v.telefone) : null,
    null,
    formatCpf(v.cpf),
    null,
  ]);
};
